require("./odometer.min");
import Accordion from "./accordion.min";
// require('./contact')

$(window).ready(function () {
  setTimeout(function () {
    var odo = $(".frame");
    odo.waypoint(
      function () {
        let elements = document.getElementsByClassName("odometer");
        for (var i = 0; i < elements.length; i++) {
          let goal = elements[i].getAttribute("odometer-goal");
          elements[i].innerHTML = goal;
        }
      },
      {
        offset: "100%",
      }
    );
  }, 500);

  setTimeout(function () {
    if ($(window).width() > 600) {
      $("#videoWrapper").html(
        ' <video muted loop autoplay class="hero-video">\n' +
          '        <source src="/wp-content/themes/marketacross_wp_theme/dist/video/letteres-hor.mp4" type="video/mp4" id="videoSource">\n' +
          "      </video>"
      );

      $(".hero-image").backgroundMove({
        movementStrength: "125",
      });

      $(".shadow-image").shadowMove({
        movementStrength: "125",
      });
    }
  }, 3000);
});

$(document).ready(function () {
  var topmargin = $(".unique .top-line").height();
  var btmmargin = $(".unique .bottom-line").height();
  var line = $(".ver-line");
  line.css("margin-top", topmargin / 2);
  line.css("margin-bottom", btmmargin / 2);
});

$(document).ready(function testimonials() {
  var speed = 0.5;
  var stay = 2;
  var $post = $(".testi");
  var slides = $post.children().length;
  var step = -100;
  var x = step;
  var pause = (speed + stay) * 1000;
  var index = 0;
  var first = $(".testi-1");

  first.clone().appendTo(first.parent());

  function myslider() {
    index++;
    if (index >= slides + 1) {
      $post.css("transition", "0s ease");
      $post.css("transform", "translateX(0)");
      x = step;
      index = 1;
    }
    setTimeout(function () {
      $post.css("transition", +speed + "s ease");
      $post.css("transform", "translateX(" + x + "%)");
      x = x + step;
    }, 150);
  }

  var myTimer = setInterval(myslider, pause);

  document.addEventListener("touchstart", handleTouchStart, false);
  document.addEventListener("touchmove", handleTouchMove, false);

  var xDown = null;
  var yDown = null;

  function getTouches(evt) {
    return (
      evt.touches || // browser API
      evt.originalEvent.touches
    ); // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        clearInterval(myTimer);
        myTimer = setInterval(myslider, pause);
        if (x == (slides + 1) * -100) {
          $post.css("transition", "0s ease");
          $post.css("transform", "translateX(0)");
          x = -100;
        }
        setTimeout(function () {
          $(".testi").css("transition", +speed + "s ease");
          $post.css("transform", "translateX(" + x + "%)");
          x = x - 100;
        }, 150);
      } else {
        clearInterval(myTimer);
        myTimer = setInterval(myslider, pause);
        if (x == -100) {
          x = slides * -100;
          $post.css("transition", "0s ease");
          $post.css("transform", "translateX(" + x + "%)");
          x = slides * -100 - 100;
        }
        setTimeout(function () {
          x = x + 200;
          $(".testi").css("transition", +speed + "s ease");
          $post.css("transform", "translateX(" + x + "%)");
          x = x - 100;
        }, 150);
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;
  }
});

$(function () {
  // var squeezebox2 = new Squeezebox({
  //
  //   wrapperEl : '#accordion',
  //   headersClass : 'myheader',
  //   foldersClass : 'mycontent',
  //   closeOthers : false,
  //   speed : '.3s',
  //
  // });
  // squeezebox2.init();

  new Accordion(".accordion-container");
});



// WEBPACK FOOTER //
// ./scripts/libraries/home.js